"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var filter_model_1 = require("../model/filter.model");
var quickfilter_model_1 = require("../model/quickfilter.model");
var search_filter_model_1 = require("../model/search-filter.model");
var portfolio_configs_model_1 = require("../model/portfolio.configs.model");
var portfolio_service_1 = require("./portfolio.service");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var wf_action_progress_dialog_component_1 = require("../simple/wf-action-progress-dialog.component");
var wf_bulk_action_popup_model_1 = require("./wf-bulk-action-popup.model");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var wf_action_limit_exceeded_dialog_component_1 = require("../simple/wf-action-limit-exceeded-dialog.component");
var wf_action_comment_dialog_component_1 = require("../simple/wf-action-comment-dialog.component");
var wf_action_error_dialog_component_1 = require("../simple/wf-action-error-dialog.component");
var extraction_service_1 = require("../../service/extraction.service");
var material_1 = require("@angular/material");
var entity_form_resolver_service_1 = require("./entity-form-resolver.service");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var table_column_type_1 = require("../model/table-column-type");
var external_actions_service_1 = require("./external-actions.service");
var router_1 = require("@angular/router");
var state_dto_1 = require("../model/state-dto");
var utilities_1 = require("../simple/utilities");
var quick_filter_dto_1 = require("../../service/quick-filter-dto");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
var PortfolioComponent = /** @class */ (function () {
    function PortfolioComponent(portfolioService, extractionService, cookieService, dialog, router, route, entityFormResolverService, externalActionsService) {
        this.portfolioService = portfolioService;
        this.extractionService = extractionService;
        this.cookieService = cookieService;
        this.dialog = dialog;
        this.router = router;
        this.route = route;
        this.entityFormResolverService = entityFormResolverService;
        this.externalActionsService = externalActionsService;
        this.minWidthOfNumberColumn = 60;
        this.minWidthOfTextColumn = 120;
        this.minWidthOfDateColumn = 130;
        this.minWidthOfBooleanColumn = 40;
        this.minWidthOfActionColumn = 40;
        this.minWidthOfDocumentColumn = 200;
        this.tableColumnType = table_column_type_1.TableColumnType;
        this._isPortfolioInitialized = false;
        this.elasticSearchLimitationCount = 10000;
        this.onPortfolioChange = new core_1.EventEmitter();
        //=======================PORTFOLIO COMPONENT====================
        // Expose enums to use in template.
        this.metaFieldType = idm_kb_service_client_js_1.MetaFieldType;
        this.formId = 0;
        this.bulkActionsLimit = 150;
        /**
             * When option has true value, workflow menu should be available in portfolio table rows
             * @type {boolean}
             */
        this.enableWfActions = false;
        /**
             * Is used to init view after all needed info is loaded.
             * @type {boolean}
             * @default
             * @protected
             */
        this._isLoading = true;
        this.ngUnsubscribe = new Subject_1.Subject();
        this._actionsLoaded = false;
        this._entityDeletedNotificationBoxVisibility = false;
        this.dataSource = new material_1.MatTableDataSource([]);
        this.classifier = {};
        this.documentObject = {};
    }
    PortfolioComponent.prototype.ngOnInit = function () {
        this.initializeInputs();
        this.state = new state_dto_1.StateDto(this.portfolioConfigs.pageSize);
    };
    PortfolioComponent.prototype.subscribeToURLParams = function () {
        var _this = this;
        return this.route.queryParams.pipe(operators_1.tap(function (params) {
            var stateParams = params && params['state'];
            if (!stateParams) {
                _this.state = _this.constructInitialOrEmptyState();
            }
            else {
                _this.state.fromJson(stateParams);
                if (!_this.state.sortingOptions) {
                    if (_this.portfolioConfigs.defaultSortingField && _this.portfolioConfigs.sortingDirection) {
                        _this.state.sortingOptions = new idm_de_core_frontend_1.SortingOptions(_this.portfolioService.searchNames.get(_this.portfolioConfigs.defaultSortingField), idm_de_core_frontend_1.SortType[_this.portfolioConfigs.sortingDirection]);
                    }
                    else {
                        //reset default sorting in case of changing portfolio (activity->project)
                        //reset default sorting in case of changing portfolio (activity->project)
                        _this.state.sortingOptions = undefined;
                    }
                }
            }
            if (!utilities_1.isNullOrEmptyObject(_this.state.quickFilters)) {
                _this.portfolioService.initWfActionsAndState(_this.state.quickFilters.selectedId);
            }
        }));
    };
    PortfolioComponent.prototype.loadPortfolioItems = function () {
        var _this = this;
        var advancedFiltersDto;
        if (this.advancedFiltersComp && this.advancedFiltersComp.length > 0 && !utilities_1.isNullOrEmptyObject(this.state.advancedFilters)) {
            advancedFiltersDto = this.advancedFiltersComp.first.buildFilterCriteriaFromOriginalFilters(this.state.advancedFilters);
        }
        var quickFiltersCriteria;
        if (this.quickFiltersComp && this.quickFiltersComp.length > 0 && !utilities_1.isNullOrEmptyObject(this.state.quickFilters)) {
            quickFiltersCriteria = this.quickFiltersComp.first.buildFilterCriteria(this.state.quickFilters);
        }
        // here can be add new filters. e.g. SEARCH FILTERS, EXTERNAL FILTERS
        var joinedAllFilters = this.portfolioService.joinAllFilters(advancedFiltersDto, quickFiltersCriteria);
        return this.portfolioService.loadPortfolioItemsWithParentFilters(joinedAllFilters, this.state.externalFilters, this.state.pageOptions, this.state.sortingOptions, undefined).pipe(operators_1.map(function (response) { return _this.portfolioService.loadPortfolioItemsCallBack(response); }));
    };
    PortfolioComponent.prototype.initFilters = function () {
        var notEmptyFilters = [];
        if (this.advancedFiltersComp && this.advancedFiltersComp.length > 0) {
            notEmptyFilters.push(this.advancedFiltersComp.first.isLoaded());
        }
        if (this.quickFiltersComp && this.quickFiltersComp.length > 0) {
            notEmptyFilters.push(this.quickFiltersComp.first.isLoaded());
        }
        if (this.searchFiltersComp && this.searchFiltersComp.length > 0) {
            notEmptyFilters.push(this.searchFiltersComp.first.isLoaded());
        }
        if (notEmptyFilters.length > 0) {
            return Observable_1.Observable.zip.apply(Observable_1.Observable, notEmptyFilters).map(function (isLoadedFlags) {
                return isLoadedFlags.filter(function (isLoadedFlag) { return !isLoadedFlag; }).length == 0;
            });
        }
        else {
            return Observable_1.Observable.of(true);
        }
    };
    PortfolioComponent.prototype.initializeInputs = function () {
        this.categoryPermissions = this.portfolioConfigs.categoryPermissions;
        this.categorySystemName = this.portfolioConfigs.categorySystemName;
        this.columns = this.portfolioConfigs.columns;
        this.deFormName = this.portfolioConfigs.deFormName;
        this.formId = this.portfolioConfigs.formId;
        this.defaultFilter = this.portfolioConfigs.defaultFilter;
        this.portfolioService.defaultFilters = this.portfolioConfigs.defaultFilter;
        //TODO @Davit, kesy componentina init anum, kesy servicein, xii????
        this.itemsNumbersPerPage = this.portfolioConfigs.itemsNumbersPerPage;
        this.bulkActionsLimit = this.portfolioConfigs.bulkActionsLimit;
        this.enableWfActions = this.portfolioConfigs.enableWfActions;
        this.hasWfBulkActions = this.portfolioConfigs.enableWorkflowBulkActions;
        this.portfolioService.acceptableActionIds = this.portfolioConfigs.workflowBulkActionIds;
        this.portfolioService.moneyColumnByCurrency = this.portfolioConfigs.moneyColumnByCurrency;
        this.portfolioService.externalBulkActions = this.externalActionsService && this.externalActionsService.getActions() ? this.externalActionsService.getActions() : [];
        this.portfolioService.externalBulkActionsByState = [];
        if (this.portfolioConfigs.enableWorkflowBulkActions) {
            this.portfolioService.acceptableActionIds = this.portfolioConfigs.workflowBulkActionIds;
        }
        else {
            this.portfolioService.acceptableActionIds = [];
        }
        this.portfolioService.portfolioColumns = [];
        if (!localStorage.getItem("isPortfolioTableView")) {
            localStorage.setItem("isPortfolioTableView", "true");
        }
        this._isPortfolioTableMode = localStorage.getItem("isPortfolioTableView") == "true";
    };
    PortfolioComponent.prototype.constructInitialOrEmptyState = function () {
        var state = new state_dto_1.StateDto(this.portfolioConfigs.pageSize);
        if (this.filters) {
            state.advancedFilters = this.filters._filterWithData["filterData"];
        }
        if (this.quickFilters) {
            state.quickFilters = new quick_filter_dto_1.QuickFilterDto(this.quickFilters._filterSystemName, -1);
        }
        if (this.externalFilters) {
            state.externalFilters = this.externalFilters;
        }
        //here can be added all initial filters. e.g. QUICK FILTER INITIAL STATE
        state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, this.portfolioConfigs.pageSize);
        if (this.portfolioConfigs.defaultSortingField && this.portfolioConfigs.sortingDirection) {
            state.sortingOptions = new idm_de_core_frontend_1.SortingOptions(this.portfolioService.searchNames.get(this.portfolioConfigs.defaultSortingField), idm_de_core_frontend_1.SortType[this.portfolioConfigs.sortingDirection]);
        }
        else {
            //reset default sorting in case of changing portfolio (activity->project)
            state.sortingOptions = undefined;
        }
        return state;
    };
    PortfolioComponent.prototype.setFilterStateToQueryParam = function (state) {
        state = state || new state_dto_1.StateDto(this.portfolioConfigs.pageSize);
        state.stateId = this.getRandomStr();
        this.portfolioService.setFilterStateToQueryParam(state);
    };
    PortfolioComponent.prototype.getRandomStr = function () {
        //generate random str - get math.random, bring to base 36 representation, as math.random return from range [0, 1) cut first two symbol(0.)
        var randomStr = Math.random().toString(36).substr(2, 5);
        return (Date.now().toString(36) + randomStr).toUpperCase();
    };
    Object.defineProperty(PortfolioComponent.prototype, "wfStateActions", {
        get: function () {
            return this._wfStateActions;
        },
        set: function (value) {
            this._wfStateActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "actionsLoaded", {
        get: function () {
            return this._actionsLoaded;
        },
        set: function (value) {
            this._actionsLoaded = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "currentPage", {
        get: function () {
            return this.state.pageOptions.offset;
        },
        set: function (currentPage) {
            if (currentPage.pageSize == 0) {
                currentPage.pageSize = this.state.pageOptions.limit;
            }
            this.selectedWorkflowEntityIds = [];
            this.isLoading = true;
            this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(currentPage.pageIndex, currentPage.pageSize);
            this.setFilterStateToQueryParam(this.state);
        },
        enumerable: true,
        configurable: true
    });
    PortfolioComponent.prototype.isHideActionsColumns = function (column) {
        var columnName = column.columnDef(column);
        return !this.showHasBulkActionsIcon && columnName == 'selectEntitiesCheckboxes';
    };
    Object.defineProperty(PortfolioComponent.prototype, "totalItemsCount", {
        get: function () {
            return this.portfolioService.totalItemsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "isPortfolioInitialized", {
        get: function () {
            return this._isPortfolioInitialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "isPortfolioTableMode", {
        get: function () {
            return this._isPortfolioTableMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        set: function (value) {
            this._isLoading = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "pageTotalCount", {
        get: function () {
            return Math.ceil(this.portfolioService.totalItemsCount / this.portfolioConfigs.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "portfolioColumns", {
        get: function () {
            return this.portfolioService.portfolioColumns;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "advancedFilters", {
        get: function () {
            return this.portfolioService.advancedFilters;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "numberFieldsCount", {
        get: function () {
            return this.portfolioService.numberFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "textFieldsCount", {
        get: function () {
            return this.portfolioService.textFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "documentFieldsCount", {
        get: function () {
            return this.portfolioService.documentFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "booleanFieldsCount", {
        get: function () {
            return this.portfolioService.booleanFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "dateFieldsCount", {
        get: function () {
            return this.portfolioService.dateFieldsCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "portfolioColumnsGeneralDynamicWidth", {
        get: function () {
            return this.portfolioService.portfolioColumnsGeneralDynamicWidth;
        },
        enumerable: true,
        configurable: true
    });
    PortfolioComponent.prototype.isNumberField = function (metField) {
        return this.portfolioService.isNumberField(metField);
    };
    PortfolioComponent.prototype.isDateField = function (metField) {
        return this.portfolioService.isDateField(metField);
    };
    PortfolioComponent.prototype.isBooleanField = function (metField) {
        return this.portfolioService.isBooleanField(metField);
    };
    PortfolioComponent.prototype.isDocumentField = function (metField) {
        return this.portfolioService.isDocumentField(metField);
    };
    PortfolioComponent.prototype.isTextField = function (metField) {
        return !this.isNumberField(metField) &&
            !this.isDateField(metField) &&
            !this.isBooleanField(metField) &&
            !this.isDocumentField(metField);
    };
    PortfolioComponent.prototype.addWorkflowColumns = function () {
        if (this.hasWfBulkActions || this.portfolioService.externalBulkActionsByState.length > 0) {
            if (this.portfolioService.portfolioColumns[0].columnType != table_column_type_1.TableColumnType.SELECT_ENTITY_CHECKBOX) {
                var checkboxColumn = {
                    columnDef: function (column) {
                        return 'selectEntitiesCheckboxes';
                    },
                    cell: function (row, column) {
                        return 0;
                    },
                    field: null,
                    columnType: table_column_type_1.TableColumnType.SELECT_ENTITY_CHECKBOX
                };
                this.portfolioService.portfolioColumns.unshift(checkboxColumn);
            }
        }
        else if (this.portfolioService.portfolioColumns[0].columnType == table_column_type_1.TableColumnType.SELECT_ENTITY_CHECKBOX) { // if portfolio columns has selectEntitiesCheckboxes, but we don't need it, so we should remove it
            // if portfolio columns has selectEntitiesCheckboxes, but we don't need it, so we should remove it
            this.portfolioService.portfolioColumns.shift(0);
        }
        if (this.hasWorkflow && (this.hasWfBulkActions || this.enableWfActions) || this.portfolioService.externalBulkActionsByState.length > 0) {
            if (this.portfolioService.portfolioColumns[this.portfolioService.portfolioColumns.length - 1].columnType != table_column_type_1.TableColumnType.WF_BULK_ACTION) {
                var wfActionColumn = {
                    columnDef: function (column) {
                        return 'bulkAction';
                    },
                    cell: function (row, column) {
                        return 0;
                    },
                    field: null,
                    columnType: table_column_type_1.TableColumnType.WF_BULK_ACTION
                };
                this.portfolioService.portfolioColumns.push(wfActionColumn);
            }
        }
        else if (this.portfolioService.portfolioColumns[this.portfolioService.portfolioColumns.length - 1].columnType == table_column_type_1.TableColumnType.WF_BULK_ACTION) {
            this.portfolioService.portfolioColumns.pop();
        }
    };
    PortfolioComponent.prototype.refreshData = function () {
        this.state = this.state || new state_dto_1.StateDto(this.portfolioConfigs.pageSize);
        this.state.stateId = this.getRandomStr();
        this.portfolioService.setFilterStateToQueryParam(this.state);
    };
    Object.defineProperty(PortfolioComponent.prototype, "portfolioColumnsDefArray", {
        get: function () {
            if (this.portfolioService.portfolioColumns) {
                this.columnsDefArray = this.portfolioService.portfolioColumns.map(function (elem) {
                    return elem.columnDef(elem);
                });
            }
            return this.columnsDefArray;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "hasWfBulkActions", {
        get: function () {
            return this.portfolioService.hasWfBulkActions;
        },
        set: function (value) {
            this.portfolioService.hasWfBulkActions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "hasWorkflow", {
        get: function () {
            return this.portfolioService.hasWorkflow;
        },
        set: function (value) {
            this.portfolioService.hasWorkflow = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "wfBulkStateActions", {
        get: function () {
            return this.portfolioService.wfBulkStateActions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "externalBulkActions", {
        get: function () {
            return this.portfolioService.externalBulkActionsByState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "currentLanguageId", {
        get: function () {
            return this.portfolioService.currentLanguageId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "selectedWfStateId", {
        get: function () {
            return this.portfolioService.selectedWfStateId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "showHasBulkActionsIcon", {
        get: function () {
            return this.dataSource.data.length > 0 &&
                (!!this.wfBulkStateActions && this.wfBulkStateActions.length > 0 || this.portfolioService.externalBulkActionsByState.length > 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "selectedWorkflowEntityIds", {
        get: function () {
            return this.portfolioService.selectedWorkflowEntityIds;
        },
        set: function (value) {
            this.portfolioService.selectedWorkflowEntityIds = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "currencies", {
        get: function () {
            return this.portfolioService.currencies;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "moneyColumnByCurrency", {
        get: function () {
            return this.portfolioService.moneyColumnByCurrency;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortfolioComponent.prototype, "entityDeletedNotificationBoxVisibility", {
        get: function () {
            return this._entityDeletedNotificationBoxVisibility;
        },
        set: function (value) {
            this._entityDeletedNotificationBoxVisibility = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets name from nameMetaFields.
     * @param {any} value
     * @returns {string}
     */
    /**
         * Gets name from nameMetaFields.
         * @param {any} value
         * @returns {string}
         */
    PortfolioComponent.prototype.getNameMeasure = /**
         * Gets name from nameMetaFields.
         * @param {any} value
         * @returns {string}
         */
    function (value) {
        if (value instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) {
            return value.getValue(this.portfolioService.portfolioLanguageId);
        }
        return value;
    };
    /**
     * Gets sort field name from {@link columnSystemNames}.
     * @param {MetaField} metaField
     * @returns {string}
     */
    /**
         * Gets sort field name from {@link columnSystemNames}.
         * @param {MetaField} metaField
         * @returns {string}
         */
    PortfolioComponent.prototype.getSortField = /**
         * Gets sort field name from {@link columnSystemNames}.
         * @param {MetaField} metaField
         * @returns {string}
         */
    function (metaField) {
        return this.portfolioService.searchNames.get(metaField.getSystemName());
    };
    PortfolioComponent.prototype.sortData = function (sort) {
        return this.portfolioService.searchNames.get(sort.active.slice(sort.active.indexOf('.') + 1));
    };
    PortfolioComponent.prototype.changeSorting = function (sort) {
        this.state.pageOptions.offset = 0;
        this.isLoading = true;
        if (sort.direction == 'asc') {
            this.state.sortingOptions = new idm_de_core_frontend_1.SortingOptions(this.getSortField(sort.active['field']), idm_de_core_frontend_1.SortType.ASC);
        }
        else if (sort.direction == 'desc') {
            this.state.sortingOptions = new idm_de_core_frontend_1.SortingOptions(this.getSortField(sort.active['field']), idm_de_core_frontend_1.SortType.DESC);
        }
        else {
            this.state.sortingOptions = undefined;
        }
        this.setFilterStateToQueryParam(this.state);
    };
    /**
     * Extracts {@link MainEntity} value to display in portfolio.
     * @param {MainEntity} mainEntity
     * @returns {number}
     */
    /**
         * Extracts {@link MainEntity} value to display in portfolio.
         * @param {MainEntity} mainEntity
         * @returns {number}
         */
    PortfolioComponent.prototype.extractMainEntityValue = /**
         * Extracts {@link MainEntity} value to display in portfolio.
         * @param {MainEntity} mainEntity
         * @returns {number}
         */
    function (mainEntity) {
        return mainEntity && mainEntity.getInstanceId();
    };
    PortfolioComponent.prototype.extractClassifier = function (classifier, compoundCategorySystemName) {
        if (classifier === null || classifier === undefined) {
            return Observable_1.Observable.of('');
        }
        else {
            this.classifier['classifier'] = classifier;
            this.classifier['systemName'] = compoundCategorySystemName;
            this.classifier['currentLanguageId'] = this.portfolioService.currentLanguageId;
            return this.classifier;
        }
    };
    PortfolioComponent.prototype.extractMultiSelect = function (classifiers, compoundSystemName) {
        return (!classifiers || classifiers.length === 0) ?
            Observable_1.Observable.of('') :
            this.extractionService.extractNameFromMultiSelect(classifiers, compoundSystemName, this.portfolioService.currentLanguageId);
    };
    /**
     * Extracts {@link MultilingualString} value with {@link currentLanguage} to display in portfolio.
     * @param {MultilingualString} mlString
     * @param isPortfolioModeTable
     * @returns {string}
     */
    /**
         * Extracts {@link MultilingualString} value with {@link currentLanguage} to display in portfolio.
         * @param {MultilingualString} mlString
         * @param isPortfolioModeTable
         * @returns {string}
         */
    PortfolioComponent.prototype.extractMultilingualString = /**
         * Extracts {@link MultilingualString} value with {@link currentLanguage} to display in portfolio.
         * @param {MultilingualString} mlString
         * @param isPortfolioModeTable
         * @returns {string}
         */
    function (mlString, isPortfolioModeTable) {
        var value = "";
        if (mlString.getValue(this.portfolioService.currentLanguageId)) {
            value = mlString.getValue(this.portfolioService.currentLanguageId);
        }
        else {
            value = mlString.getValue(this.portfolioService.portfolioLanguageId);
        }
        if (!isPortfolioModeTable && value == "") {
            value = "NO DATA";
        }
        return value;
    };
    PortfolioComponent.prototype.extractAccounting = function (metaField, accounting) {
        if (accounting && accounting["currencyMoney"]) {
            var name_1 = metaField.getSystemName();
            var currencyId_1 = this.moneyColumnByCurrency.get(name_1);
            var currencyModel_1 = this.currencies.get(currencyId_1);
            if (!currencyModel_1) {
                this.currencies.forEach(function (value, key) {
                    if (value.isDefault) {
                        currencyModel_1 = value;
                        currencyId_1 = currencyModel_1.id;
                    }
                });
            }
            accounting["symbol"] = currencyModel_1.symbol;
            accounting["currencyId"] = currencyId_1;
            return accounting;
        }
        return null;
    };
    PortfolioComponent.prototype.extractMoney = function (money) {
        if (money && (money.amount || money.amount === 0)) {
            var currencyModel = this.currencies.get(money.currencyId);
            money["symbol"] = currencyModel.symbol;
            return money;
        }
        return null;
    };
    PortfolioComponent.prototype.extractImageDocumentOld = function (documentId, instanceId, documentSystemName) {
        return this.extractionService.extractImageDocument(documentId, instanceId, this.categorySystemName, documentSystemName['field'].getSystemName());
    };
    PortfolioComponent.prototype.extractImageDocument = function (documentId, instanceId, documentSystemName) {
        if (documentSystemName) {
            this.documentObject['documentId'] = documentId;
            this.documentObject['instanceId'] = instanceId;
            this.documentObject['categorySystemName'] = this.categorySystemName;
            this.documentObject['documentSystemName'] = documentSystemName['field'].getSystemName();
        }
        return this.documentObject;
    };
    PortfolioComponent.prototype.getCellId = function (row, index) {
        return row.entityInstanceId + '-' + index;
    };
    PortfolioComponent.prototype.doExternalBulkAction = function (action) {
        if (this.selectedWorkflowEntityIds.length > 0) {
            action.doAction(this.selectedWorkflowEntityIds);
        }
        else {
            this.portfolioService.getEntityIds().takeUntil(this.ngUnsubscribe).subscribe(function (ids) {
                action.doAction(ids);
            });
        }
    };
    PortfolioComponent.prototype.doWfBulkAction = function (action) {
        var _this = this;
        var itemsCountToSubmit = this.selectedWorkflowEntityIds.length > 0 ? this.selectedWorkflowEntityIds.length : this.totalItemsCount;
        var dialogRef;
        if (itemsCountToSubmit > this.bulkActionsLimit) {
            dialogRef = this.dialog.open(wf_action_limit_exceeded_dialog_component_1.WfActionLimitDialog, {
                width: '500px',
                data: this.bulkActionsLimit
            });
        }
        else {
            this.portfolioService.isWfCommentFieldRequired(action.getTargetStateId()).takeUntil(this.ngUnsubscribe).subscribe(function (isReq) {
                dialogRef = _this.dialog.open(wf_action_comment_dialog_component_1.WfActionCommentDialog, {
                    width: '500px',
                    data: {
                        'itemsCount': itemsCountToSubmit,
                        'currentLanguageId': _this.currentLanguageId,
                        'actionName': action.getName().getValue(_this.currentLanguageId),
                        'isCommentRequired': isReq
                    }
                });
                dialogRef.afterClosed().takeUntil(_this.ngUnsubscribe).subscribe(function (actionData) {
                    if (actionData.submit) {
                        var comment_1 = actionData.comment;
                        var bulkActionIndex_1 = 0;
                        var bulkActionCount_1 = 25;
                        if (_this.selectedWorkflowEntityIds.length > 0) {
                            _this.processBulkActions(_this.selectedWorkflowEntityIds, itemsCountToSubmit, bulkActionIndex_1, bulkActionCount_1, action.getId(), comment_1);
                        }
                        else {
                            _this.portfolioService.getEntityIds().takeUntil(_this.ngUnsubscribe).subscribe(function (ids) {
                                _this.processBulkActions(ids, itemsCountToSubmit, bulkActionIndex_1, bulkActionCount_1, action.getId(), comment_1);
                            });
                        }
                    }
                });
            });
        }
    };
    PortfolioComponent.prototype.processBulkActions = function (ids, itemsCountToSubmit, bulkActionIndex, bulkActionCount, actionId, comment) {
        var _this = this;
        var entityIds = ids.slice(bulkActionIndex * bulkActionCount, bulkActionIndex * bulkActionCount + bulkActionCount);
        this.portfolioService.doWfBulkActions(entityIds, actionId, comment);
        var popupData = new wf_bulk_action_popup_model_1.WfBulkActionPopupModel(itemsCountToSubmit, 0, 0);
        var progressDialogRef = this.dialog.open(wf_action_progress_dialog_component_1.WfActionProgressDialog, {
            width: '500px',
            data: popupData
        });
        this.portfolioService.wfBulkActionObservable.takeUntil(this.ngUnsubscribe).subscribe(function (data) {
            bulkActionIndex++;
            popupData.failedItems += data.failedItems;
            popupData.movedItems += data.movedItems;
            if (itemsCountToSubmit > bulkActionIndex * bulkActionCount) {
                var entityIds_1 = ids.slice(bulkActionIndex * bulkActionCount, bulkActionIndex * bulkActionCount + bulkActionCount);
                _this.portfolioService.doWfBulkActions(entityIds_1, actionId, comment);
            }
            else {
                _this.emitPortfolioChange();
            }
        });
        progressDialogRef.afterClosed().takeUntil(this.ngUnsubscribe).subscribe(function () {
            _this.isLoading = true;
            _this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, _this.state.pageOptions.limit);
            _this.setFilterStateToQueryParam(_this.state);
        });
    };
    PortfolioComponent.prototype.doWfAction = function (action, entityInstanceId) {
        var _this = this;
        this.portfolioService.doWfAction(entityInstanceId, action.getId()).takeUntil(this.ngUnsubscribe).subscribe(function (responseStatus) {
            var messageKey;
            switch (responseStatus) {
                case idm_de_service_client_js_1.ResponseStatus.LOCKED: {
                    messageKey = "portfolio.wf.action.locked.error.message";
                    break;
                }
                case idm_de_service_client_js_1.ResponseStatus.CONFLICT: {
                    messageKey = "portfolio.wf.action.conflict.error.message";
                    break;
                }
                case idm_de_service_client_js_1.ResponseStatus.FORBIDDEN: {
                    messageKey = "portfolio.wf.action.forbidden.error.message";
                    break;
                }
                case idm_de_service_client_js_1.ResponseStatus.NOT_ACCEPTABLE: {
                    messageKey = "portfolio.wf.action.not.acceptable.error.message";
                    break;
                }
                case idm_de_service_client_js_1.ResponseStatus.NOT_FOUND: {
                    messageKey = "portfolio.wf.action.not.found.error.message";
                    break;
                }
            }
            if (responseStatus == idm_de_service_client_js_1.ResponseStatus.OK) {
                setTimeout(function () {
                    _this.isLoading = true;
                    _this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, _this.state.pageOptions.limit);
                    _this.setFilterStateToQueryParam(_this.state);
                }, 1000);
                _this.emitPortfolioChange();
            }
            else {
                var errorDialogRef = _this.dialog.open(wf_action_error_dialog_component_1.WfActionErrorDialog, {
                    width: '500px',
                    data: messageKey
                });
                errorDialogRef.afterClosed().takeUntil(_this.ngUnsubscribe).subscribe(function () {
                    _this.isLoading = true;
                    _this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, _this.state.pageOptions.limit);
                    _this.setFilterStateToQueryParam(_this.state);
                });
            }
        });
    };
    PortfolioComponent.prototype.loadWfActions = function (entityInstanceId) {
        var _this = this;
        this.actionsLoaded = false;
        this.portfolioService.loadWfActions(this.categorySystemName, entityInstanceId).subscribe(function (actions) {
            _this.wfStateActions = actions;
            _this.actionsLoaded = true;
        }, function (err) {
            if (err.status === 404) {
                _this.wfStateActions = [];
                _this.actionsLoaded = true;
                if (_this.entityDeletedNotificationBoxVisibility === false) {
                    _this.entityDeletedNotificationBoxVisibility = true;
                    _this.entityDeletedNotificationBoxTimeout = setTimeout(function () {
                        _this.entityDeletedNotificationBoxVisibility = false;
                    }, 3500);
                }
            }
        });
    };
    PortfolioComponent.prototype.clearNotificationBoxTimeout = function () {
        if (this.entityDeletedNotificationBoxTimeout) {
            clearTimeout(this.entityDeletedNotificationBoxTimeout);
            this.entityDeletedNotificationBoxVisibility = false;
        }
    };
    PortfolioComponent.prototype.selectEntity = function (id, checked) {
        if (checked) {
            this.selectedWorkflowEntityIds.push(id);
        }
        else {
            this.selectedWorkflowEntityIds.splice(this.selectedWorkflowEntityIds.indexOf(id), 1);
        }
    };
    PortfolioComponent.prototype.selectAllEntities = function (checked) {
        if (checked) {
            this.selectedWorkflowEntityIds = this.dataSource.data.map(function (r) { return r.entityInstanceId; });
        }
        else {
            this.selectedWorkflowEntityIds = [];
        }
    };
    PortfolioComponent.prototype.trackByRow = function (index, item) {
        return item.entityInstanceId;
    };
    PortfolioComponent.prototype.trackByPortfolioColumns = function (index, item) {
        return item.columnDef(item);
    };
    PortfolioComponent.prototype.trackByWfActions = function (index, item) {
        return item.getId();
    };
    PortfolioComponent.prototype.trackByActions = function (index, item) {
        return item.id;
    };
    //=======================FILTERS CHANGE====================
    //=======================FILTERS CHANGE====================
    PortfolioComponent.prototype.applyFilters = 
    //=======================FILTERS CHANGE====================
    function (filters) {
        this.isLoading = true;
        this.portfolioService.onChangeFilterHandler(filters);
        this.state.advancedFilters = filters;
        this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, this.state.pageOptions.limit);
        this.setFilterStateToQueryParam(this.state);
    };
    PortfolioComponent.prototype.applyQuickFilters = function (quickFilterDto) {
        this.isLoading = true;
        this.portfolioService.onChangeQuickFilterHandler(quickFilterDto);
        this.state.quickFilters = quickFilterDto;
        this.state.pageOptions = new idm_de_core_frontend_1.PagingOptions(0, this.state.pageOptions.limit);
        this.setFilterStateToQueryParam(this.state);
    };
    PortfolioComponent.prototype.applySearchFilters = function (searchFilters) {
        this.isLoading = true;
        this.portfolioService.onChangeSearchFilterHandler(searchFilters);
    };
    PortfolioComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    PortfolioComponent.prototype.changeToPortfolioTableMode = function () {
        this._isPortfolioTableMode = true;
        localStorage.setItem("isPortfolioTableView", 'true');
    };
    PortfolioComponent.prototype.changeToPortfolioGridMode = function () {
        this._isPortfolioTableMode = false;
        localStorage.setItem("isPortfolioTableView", 'false');
    };
    PortfolioComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            var filtersInited = _this.initFilters();
            var portfolioConfigurationsInited = _this.portfolioService.init(_this.categorySystemName, _this.columns, _this.quickFilters ? _this.quickFilters._filterSystemName : null, _this.sortingOptions, _this.categoryPermissions, _this.portfolioConfigs.additionalFieldsToLoad, 
            // this.externalFilters,
            // this.externalFilters,
            _this.portfolioConfigs.categoryFieldsToLoad);
            zip_1.zip(filtersInited, portfolioConfigurationsInited)
                .pipe(operators_1.switchMap(function (_a) {
                var isFiltersInited = _a[0], isPortfolioConfigurationsInited = _a[1];
                if (isFiltersInited && isPortfolioConfigurationsInited) {
                    return _this.subscribeToURLParams();
                }
                else {
                    console.log("Something is not inited. It seems you have wrong configurations in advancedFilters or portfolio");
                }
                return Observable_1.Observable.empty();
            }), operators_1.switchMap(function () { return _this.loadPortfolioItems(); }))
                .takeUntil(_this.ngUnsubscribe)
                .subscribe(function (portfolioRowModels) {
                _this.addWorkflowColumns();
                _this.selectedWorkflowEntityIds = [];
                _this.isLoading = false;
                _this.dataSource.data = portfolioRowModels;
                _this._isPortfolioInitialized = true;
            }, function (err) {
                console.error("error -> " + err);
            });
        });
    };
    PortfolioComponent.prototype.resetAdvancedFilters = function () {
        this.advancedFiltersComp.first.reset();
    };
    PortfolioComponent.prototype.emitPortfolioChange = function () {
        this.onPortfolioChange.emit();
    };
    PortfolioComponent.decorators = [
        { type: core_1.Component, args: [{
                    moduleId: module.id + '',
                    selector: 'sis-dynamic-portfolio',
                    styles: [require('./portfolio.component.css')],
                    template: require('./portfolio.component.html'),
                },] },
    ];
    /** @nocollapse */
    PortfolioComponent.ctorParameters = function () { return [
        { type: portfolio_service_1.PortfolioService, },
        { type: extraction_service_1.ExtractionService, },
        { type: idm_authentication_client_js_1.CookieService, },
        { type: material_1.MatDialog, },
        { type: router_1.Router, },
        { type: router_1.ActivatedRoute, },
        { type: entity_form_resolver_service_1.EntityFormResolverService, decorators: [{ type: core_1.Optional },] },
        { type: external_actions_service_1.ExternalActionsService, decorators: [{ type: core_1.Optional },] },
    ]; };
    PortfolioComponent.propDecorators = {
        "filters": [{ type: core_1.Input },],
        "quickFilters": [{ type: core_1.Input },],
        "searchFilters": [{ type: core_1.Input },],
        "externalFilters": [{ type: core_1.Input },],
        "advancedFiltersComp": [{ type: core_1.ViewChildren, args: ['advancedFiltersComp',] },],
        "quickFiltersComp": [{ type: core_1.ViewChildren, args: ['quickFiltersComp',] },],
        "searchFiltersComp": [{ type: core_1.ViewChildren, args: ['searchFiltersComp',] },],
        "portfolioConfigs": [{ type: core_1.Input },],
        "onPortfolioChange": [{ type: core_1.Output },],
        "paginator": [{ type: core_1.ViewChild, args: [material_1.MatPaginator,] },],
        "sort": [{ type: core_1.ViewChild, args: [material_1.MatSort,] },],
    };
    return PortfolioComponent;
}());
exports.PortfolioComponent = PortfolioComponent;
//# sourceMappingURL=portfolio.component.js.map